import type { DateRangePreset } from '~shared/ui/date-range-picker';

import {
  endOfDay,
  startOfDay,
  startOfMonth,
  subMonths,
  subWeeks,
} from 'date-fns';

export const PERIOD_PRESETS: DateRangePreset[] = [
  {
    title: 'Last 7 days',
    value: {
      startDate: startOfDay(subWeeks(new Date(), 1)).toISOString(),
      endDate: endOfDay(new Date()).toISOString(),
    },
  },
  {
    title: 'Last 14 days',
    value: {
      startDate: startOfDay(subWeeks(new Date(), 2)).toISOString(),
      endDate: endOfDay(new Date()).toISOString(),
    },
  },
  {
    title: 'Last month',
    value: {
      startDate: startOfDay(subMonths(new Date(), 1)).toISOString(),
      endDate: endOfDay(new Date()).toISOString(),
    },
  },
];

export const PERIOD_MIN_DATE = startOfDay(
  startOfMonth(subMonths(new Date(), 1))
);

export const PERIOD_MAX_DATE = endOfDay(new Date());
